import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';

import Modal from 'react-bootstrap-modal';
import ReactPhoneInput from 'react-telephone-input';
import {t} from 'l10n';

import {Form, ErrorContainer} from 'form';

import ModalConfimPhone from './ModalConfimPhone';

import '../../sass/react-tel-input.scss';
import '../../sass/modals/modalChangeEmail.scss';
import flags from '../../images/flags.png';

import { changePhone } from 'backend-helpers/member';

const ModalChangePhone = ({ user, closeFn, onSuccess }) => {
    const [phone, setPhone] = useState('');
    const [showConfirm, setShowConfirm] = useState(false);
    
    const onSubmit = (formData, setErrors) => {
        changePhone({ action: 'request', phone })
            .then(() => setShowConfirm(true))
            .catch(error => setErrors(error.message));
    };

    const onChange = (number) => setPhone(number);

    return (
        <Fragment>
            {showConfirm ?
                <ModalConfimPhone phone={phone} closeFn={closeFn} onSuccess={onSuccess}/>
                : 
                <Modal className="change-email" show onHide={closeFn}>
                    <Modal.Body>
                        <div className="close" onClick={closeFn} />
                        <p className="modal-title">{t('Change phone')}</p>
                        <div className="form">
                            <Form onSubmit={onSubmit}>
                                <ErrorContainer data-errorcontainer={true} />
                                {user && user.phone && (
                                    <div className="form-group">
                                        <label>{t('Current phone number:')}</label>
                                        <span>{user.phone}</span>
                                    </div>
                                )}
                                <div className="form-group phone-group">
                                    <label>{t('New phone number:')}</label>
                                    <div className="flex space-between">
                                        <ReactPhoneInput
                                            name="phone"
                                            initialValue="+33"
                                            defaultCountry="fr"
                                            flagsImagePath={flags}
                                            onChange={number => onChange(number)}
                                        />
                                    </div>
                                </div>
                                <div className="form-group-buttons">
                                    <button type="submit" className="save-name">{t('Save')}</button>
                                    <button type="button" className="close-name" onClick={closeFn}>{t('Cancel')}</button>
                                </div>
                            </Form>
                        </div>
                    </Modal.Body>
                </Modal>
            }
        </Fragment>
    )
};

ModalChangePhone.propTypes = {
    user: PropTypes.object,
    closeFn: PropTypes.func.isRequired,
    onSuccess: PropTypes.func.isRequired,
};

export default ModalChangePhone;


// WEBPACK FOOTER //
// ./src/components/modals/ModalChangePhone.js